"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelatedDeanSchema = exports.DeanCreateDTOSchema = exports.DeanIMSchema = exports.DeanSchema = void 0;
const z = __importStar(require("zod"));
const disclosure_1 = require("./disclosure");
const contributor_1 = require("./contributor");
exports.DeanSchema = z.object({
    id: z.string(),
    name: z.string().min(1),
    email: z.string().trim().email(),
    signoffStatus: contributor_1.SignoffStatusSchema,
    disclosureId: z.string(),
    reason: z.string().nullable(),
});
exports.DeanIMSchema = exports.DeanSchema.omit({
    id: true,
});
exports.DeanCreateDTOSchema = exports.DeanSchema.omit({
    id: true,
    disclosureId: true,
});
/**
 * RelatedDeanSchema contains all relations on your model in addition to the scalars
 *
 * NOTE: Lazy required in case of potential circular dependencies within schema
 */
exports.RelatedDeanSchema = z.lazy(() => exports.DeanSchema.extend({
    disclosure: disclosure_1.DisclosureSchema,
}));
